// Markup to strip: comments ("<!--StartFragment-->" from pasted HTML),
// declarations ("<!DOCTYPE …>"), and tags — "<" or "</" followed by a letter,
// so plain-text comparisons like "x < 5 and y > 3" aren't mistaken for one.
// Same as weavewords-mobile's utils/stripHtml.ts.
const TAG_RE = /<!--[\s\S]*?-->|<![^>]*>|<\/?[a-z][^>]*>/gi;

const NAMED_ENTITIES: Record<string, string> = {
    amp: '&',
    lt: '<',
    gt: '>',
    quot: '"',
    apos: "'",
    nbsp: ' ',
};

// Decodes the entities contentEditable's innerHTML produces (&amp; &lt; &gt;
// &quot; &nbsp; and numeric ones like &#39;). Unknown named entities are kept.
export function decodeHtmlEntities(str: string): string {
    return str.replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, (entity, code: string) => {
        if (code[0] === '#') {
            const n = code[1] === 'x' || code[1] === 'X' ? parseInt(code.slice(2), 16) : parseInt(code.slice(1), 10);
            return n > 0 && n <= 0x10ffff ? String.fromCodePoint(n) : entity;
        }
        // Own-property check: a plain lookup would resolve "&constructor;" or
        // "&tostring;" to Object.prototype's functions.
        const name = code.toLowerCase();
        return Object.prototype.hasOwnProperty.call(NAMED_ENTITIES, name) ? NAMED_ENTITIES[name] : entity;
    });
}

// Tags are removed before decoding, so an escaped "&lt;b&gt;" comes out as the
// literal text "<b>" rather than being stripped as a tag.
export function stripHtml(str: string): string {
    return decodeHtmlEntities(str.replace(TAG_RE, ''));
}
